// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__kOVk-","dense":"_type_dense__2I7Yd","slide-fwd-right":"_type_slide-fwd-right__1XAgS"};